import React from 'react';
// import { Redirect } from "react-router-dom";
import Cookies from 'js-cookie';
// import Highlighter from 'react-highlight-words';
// import { Link } from "react-router-dom";
import {
	// Card,
	Row,
	Col,
	Input,
	Button,
	// Table,
	// Modal,
	message,
	// Alert,
	Select,
	Spin,
	Form,
	DatePicker,
} from 'antd';
import {
	// TeamOutlined,
	SearchOutlined,
	// PlusOutlined,
	// FormOutlined,
	// CloseSquareOutlined,
	// ExclamationCircleOutlined,
	// DiffOutlined,
	// RedoOutlined,
	CopyOutlined,
	PrinterOutlined
} from '@ant-design/icons';

// import axios from 'axios';

import { connect } from 'react-redux';
import {
	initHandler,
	ajaxViewHandler,
	ajaxHandler,
	setConfig,
} from "../../store/actions";

import Config from '../../Config';
import { Helmet } from "react-helmet";

import moment from "moment";

import '../../assets/laporan.css';

const configClass = {
	title: 'LAPORAN SUM32',
	apiUrl: {
		data: 'laporan/api/sum32/',
		warna_plat: "master/api/plat",
		jenis_kendaraan: "master/api/jenis/kendaraan/",
		payment: "master/api/payment/?include_deleted=true",
		upt: "pegawai/api/upt/",
		kabupaten: "master/api/kabupaten/",
	},
	pageUrl: {
		cetak: '/laporan/harian-sum32'
	},
	breadCrumb: [
		(
			<span>
				<CopyOutlined /> laporan
			</span>
		),
		'sum32'
	]

}

const config = new Config();

class LapSUM32 extends React.Component {
	formRef = React.createRef();

	constructor(props) {
		super(props);
		this.config = new Config();
		this.state = {
			loading: false,
			data: null,
			loadingUpt: false,
			listUpt: [],
			loadingKabupaten: null,
			listKabupaten: [],
			kabupaten_id: "",
			err: false,

			loadingWarnaPlat: false,
			listWarnaPlat: [],

			loadingJenisKendaraan: false,
			listJenisKendaraan: [],

			loadingPayment: false,
			listPayment: [],

			namauptppd: 'SAMSAT PALANGKARAYA',

			filter: "",


		}
	}

	UNSAFE_componentWillMount() {
		this.props.initHandler();
	}

	componentDidMount() {
		this.loadMasterList();
		this.initKabupatenFromCookie();
		// this.getData();
	}

	// Kabupaten yang dipilih pegawai saat login (cookie _upt) - dipakai untuk
	// auto-isi + kunci form Kabupaten pada non-superadmin, sama seperti
	// LapPenggunaanNoticeRusak.jsx.
	initKabupatenFromCookie() {
		try {
			const rawCookie = Cookies.get(this.config.get_cookie_name() + '_upt');
			if (!rawCookie) return;
			const parsed = JSON.parse(decodeURIComponent(rawCookie));
			const kabupatenId = parsed.kabupaten;
			if (!kabupatenId) return;
			this.setState({ kabupaten_id: kabupatenId });
			setTimeout(() => {
				if (this.formRef.current) {
					this.formRef.current.setFieldsValue({ kabupaten: kabupatenId });
				}
			}, 0);
			this.getMasterList({
				destination: { stateProgressName: 'loadingUpt', endPoint: configClass.apiUrl.upt + '?kabupaten=' + kabupatenId, stateDestination: 'listUpt' },
				nextDestination: null,
			});
		} catch (err) {
			console.warn('Cookie _upt tidak valid:', err);
		}
	}

	isKabupatenLocked() {
		try {
			const rawCookie = Cookies.get(this.config.get_cookie_name() + '_upt');
			if (!rawCookie) return false;
			const parsed = JSON.parse(decodeURIComponent(rawCookie));
			return Boolean(parsed.kabupaten && parsed.id);
		} catch (err) {
			return false;
		}
	}

	loadMasterList() {
		const rule = [
			{
				destination: {
					stateProgressName: "loadingJenisKendaraan",
					endPoint: configClass.apiUrl.jenis_kendaraan,
					stateDestination: "listJenisKendaraan",
				},
				nextDestination: {
					stateProgressName: "loadingWarnaPlat",
					endPoint: configClass.apiUrl.warna_plat,
					stateDestination: "listWarnaPlat",
					next: null,
				},
			},
			{
				destination: {
					stateProgressName: "loadingPayment",
					endPoint: configClass.apiUrl.payment,
					stateDestination: "listPayment",
				},
				nextDestination: {
					stateProgressName: "loadingKabupaten",
					endPoint: configClass.apiUrl.kabupaten,
					stateDestination: "listKabupaten",
					next: null,
				},
			},
		];

		this.setState({
			errComponent: false,
		});

		rule.map((item, index) => {
			if (index == rule.length - 1) {
				this.getMasterList(item, true);
			} else {
				this.getMasterList(item);
			}
		});
	}

	async getMasterList(rule, isFinal = false) {
		var destination = rule.destination;
		var nextDestination = rule.nextDestination;
		this.setState({ [destination.stateProgressName]: true });
		this.props
			.ajaxViewHandler("get", destination.endPoint)
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					if (data.count != undefined) {
						let newState = null;
						if (this.state[destination.stateDestination].length == 0) {
							newState = data;
						} else {
							if (destination.stateProgressName.includes("_searching")) {
								newState = data;
							} else {
								const oldState = this.state[destination.stateDestination];
								newState = {
									count: data.count,
									next: data.next,
									previous: data.previous,
									results: [...oldState.results, ...data.results],
								};
							}
						}
						this.setState({
							[destination.stateDestination]: newState,
						});
					} else if (data.results != undefined) {
						this.setState({
							[destination.stateDestination]: data.results,
						});
					} else {
						if (Array.isArray(data)) {
							this.setState({
								[destination.stateDestination]: data,
							});
						} else {
							this.setState({
								[destination.stateDestination]: [data],
							});
						}
					}
					if (isFinal) {
						if (this.props.match.params.id != undefined) {
							// this.preview(this.props.match.params.id);
						}
					}
				} else {
					this.setState({
						errComponent: true,
					});
				}
				this.setState({ [destination.stateProgressName]: false });
			})
			.catch((response) => {
				//console.log('gagal_get_master', response);
				message.error({
					content: "gagal request data, coba lagi",
					duration: 2,
					key: "toast",
				});
				this.setState({
					errTitle: "gagal request data master",
					errMsg: response,
				});
				this.setState({ [destination.stateProgressName]: false });
			});
		//next function
		if (nextDestination != null) {
			const next = {
				destination: {
					stateProgressName: nextDestination.stateProgressName,
					endPoint: nextDestination.endPoint,
					stateDestination: nextDestination.stateDestination,
				},
				nextDestination: nextDestination.next,
			};
			this.getMasterList(next);
		}
	}

	generateSelect(stateName, url, key, value, keyDisplay = "") {
		return this.state["loading" + stateName] ? (
			<img src={process.env.PUBLIC_URL + "/loading_crop.gif"} height="50" />
		) : (
			<Select
				autoFocus
				showSearch
				placeholder={"Cari / Pilih " + stateName}
				disabled={stateName === "Kabupaten" && this.isKabupatenLocked()}
				optionFilterProp="children"
				onSearch={(val) => {
					const sep = url.includes('?') ? '&' : '?';
					let urls = url + sep + "search=" + val;
					if (stateName == "Upt") {
						urls = `${url}${sep}kabupaten=${this.state.kabupaten_id}&search=${val}`;
					}
					const rule = {
						destination: {
							stateProgressName: "loading" + stateName + "_searching",
							endPoint: urls,
							stateDestination: "list" + stateName,
						},
						nextDestination: null,
					};
					this.getMasterList(rule);
				}}
				onPopupScroll={(e) => {
					e.persist();
					let target = e.target;
					if (target.scrollTop + target.offsetHeight == target.scrollHeight) {
						if (
							this.state["list" + stateName].next != undefined &&
							this.state["list" + stateName].next != null
						) {
							const rule = {
								destination: {
									stateProgressName: "loading" + stateName + "Paging",
									endPoint: this.state["list" + stateName].next,
									stateDestination: "list" + stateName,
								},
								nextDestination: null,
							};
							this.getMasterList(rule);
						}
					}
				}}
				allowClear
				style={{
					width: "100%",
				}}
				onChange={(val) => {
					if (stateName == "Kabupaten") {
						this.setState({
							kabupaten_id: val
						}, () => {
							const rule = {
								destination: {
									stateProgressName: "loadingUpt",
									endPoint: configClass.apiUrl.upt + "?kabupaten=" + val,
									stateDestination: "listUpt",
								},
								nextDestination: null,
							};
							this.getMasterList(rule);
						});
					}
				}}
				size={"small"}
			>
				{this.state["loading" + stateName + "_searching"] == true && (
					<Select.Option value="">
						<Spin size="small" />
					</Select.Option>
				)}
				{this.state["list" + stateName].count != undefined
					? this.state["list" + stateName].results.map((item) => (
						<Select.Option value={item[key]}>
							{keyDisplay == ""
								? item[key] + " - " + item[value]
								: item[keyDisplay] + " - " + item[value]}
						</Select.Option>
					))
					: this.state["list" + stateName].map((item) => (
						<Select.Option value={item[key]}>
							{keyDisplay == ""
								? item[key] + " - " + item[value]
								: item[keyDisplay] + " - " + item[value]}
						</Select.Option>
					))}
				{this.state["list" + stateName] != undefined &&
					this.state["list" + stateName].next != undefined && (
						<Select.Option value="">
							<Spin size="small" />
						</Select.Option>
					)}
			</Select>
		);
	}

	handleSubmit = (values) => {
		var filter = "";
		for (var key in values) {
			if (values[key] != undefined) {
				if (filter == "") {
					filter = "?" + key + "=" + values[key];
				} else {
					filter += "&" + key + "=" + values[key];
				}
			}
		}
		this.setState({
			filter: filter
		});
		this.getData(filter)
	};

	handlePrint = () => {
		// Inject @page landscape sementara, dihapus setelah cetak
		const styleEl = document.createElement('style');
		styleEl.id = 'sum32-landscape';
		styleEl.textContent = '@media print { @page { size: A4 landscape; margin: 1cm; } }';
		document.head.appendChild(styleEl);

		const printEl = document.querySelector('.lap-sum32-print-only');
		if (!printEl) { document.head.removeChild(styleEl); return; }
		const parent  = printEl.parentNode;
		const nextSib = printEl.nextSibling;
		document.body.appendChild(printEl);
		const siblings = Array.from(document.body.children).filter(el => el !== printEl);
		siblings.forEach(el => { el.style.display = 'none'; });

		window.print();

		siblings.forEach(el => { el.style.display = ''; });
		if (nextSib) parent.insertBefore(printEl, nextSib);
		else parent.appendChild(printEl);
		document.head.removeChild(styleEl);
	}

	async getData(filter) {
		message.loading({ content: 'Menampilkan laporan...', duration: 0, key: 'toast' });
		this.setState({
			loading: true,
			err: false,
			data: null,
		});

		this.props.ajaxViewHandler('get', configClass.apiUrl.data + filter)
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					message.destroy();
					this.setState({
						loading: false,
						data: data,
						err: false
					});
				} else {
					const errTitle = 'error get laporan';
					this.setState({
						loading: false,
						data: null,
						err: true,
						errMsg: this.props.responseMsg
					});
					message.error({ content: errTitle, duration: 2, key: 'toast' });
				}
			}).catch((response) => {
				this.setState({
					loading: false,
					data: null,
					err: true,
					errMsg: 'unknown response'
				});
				console.log('gagal_get_laporan', response);
				message.error({ content: 'gagal request data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	renderLaporanContent() {
		const { data } = this.state;
		if (!data) return null;
		let no = 0;
		return (
			<div>
				<div className="judul-laporan teks-tengah">
					BUKU PENERIMAAN HARIAN PKB, BBNKB, DAN SWDKLLJ<br />
					DI UPTPPD {data.summary.nama_samsat}
				</div>
				<div className="judul-laporan">
					HARI, TANGGAL : {data.summary.hari_tanggal}
				</div>
				<table className="laporan-table" border="1" cellPadding="5" style={{ width: '100%', borderCollapse: 'collapse' }}>
					<thead>
						<tr>
							<th rowSpan="2">NO</th>
							<th rowSpan="2" style={{ minWidth: 200 }}>NAMA<br />DAN ALAMAT PEMILIK</th>
							<th rowSpan="2" style={{ minWidth: 80 }}>NO POLISI</th>
							<th colSpan="3">IDENTITAS KENDARAAN</th>
							<th rowSpan="2" style={{ minWidth: 80 }}>JENIS<br />KENDARAAN</th>
							<th rowSpan="2" style={{ minWidth: 80 }}>NO NOTICE<br />NO KOHIR<br />NO SKUM</th>
							<th rowSpan="2">POKOK PKB<br />DENDA PKB<br />JUMLAH PKB</th>
							<th rowSpan="2">POKOK BBN I<br />DENDA BBN I<br />JUMLAH BBN I</th>
							<th rowSpan="2">POKOK BBN II<br />DENDA BBN II<br />JUMLAH BBN II</th>
							<th rowSpan="2">POKOK SWD<br />DENDA SWD<br />JUMLAH SWD</th>
							<th rowSpan="2">OPSEN POKOK BBNKB</th>
							<th rowSpan="2">OPSEN POKOK PKB</th>
							<th rowSpan="2">JUMLAH POKOK<br />JUMLAH DENDA<br />JUMLAH SEMUA</th>
						</tr>
						<tr>
							<th style={{ minWidth: 100 }}>MEREK</th>
							<th style={{ minWidth: 60 }}>TAHUN</th>
							<th style={{ minWidth: 60 }}>CC</th>
						</tr>
					</thead>
					<tbody>
						{data.data.items.map((item, id) => {
							no++;
							return (
								<tr key={id}>
									<td className="teks-tengah">{no}</td>
									<td>
										{item.nama_wp}<br />
										{item.alamat_wp}
									</td>
									<td className="teks-tengah">
										{item.nopol.toUpperCase()}<br />
										{moment(item.masa_pajak_mulai).format('DD-MM-YYYY')}
									</td>
									<td>
										{item.merk_kendaraan}<br />
										{item.tipe_nama}
									</td>
									<td className="teks-tengah">{item.thn_buat}</td>
									<td className="teks-tengah">{item.silinder}</td>
									<td className="teks-tengah">{item.jenis_kendaraan}</td>
									<td className="teks-tengah">{item.no_notice}</td>
									<td className="teks-kanan">
										{item.pokok_pkb.toLocaleString('id')}<br />
										{item.denda_pkb.toLocaleString('id')}<br />
										{(item.pokok_pkb + item.denda_pkb).toLocaleString('id')}
									</td>
									<td className="teks-kanan">
										{item.pokok_bbnkb_i.toLocaleString('id')}<br />
										{item.denda_bbnkb_i.toLocaleString('id')}<br />
										{(item.pokok_bbnkb_i + item.denda_bbnkb_i).toLocaleString('id')}
									</td>
									<td className="teks-kanan">
										{item.pokok_bbnkb_ii.toLocaleString('id')}<br />
										{item.denda_bbnkb_ii.toLocaleString('id')}<br />
										{(item.pokok_bbnkb_ii + item.denda_bbnkb_ii).toLocaleString('id')}
									</td>
									<td className="teks-kanan">
										{item.pokok_swdkllj.toLocaleString('id')}<br />
										{item.denda_swdkllj.toLocaleString('id')}<br />
										{(item.pokok_swdkllj + item.denda_swdkllj).toLocaleString('id')}
									</td>
									<td className="teks-kanan">
										{item.opsen_bbnkb.toLocaleString('id')}<br />&nbsp;<br />&nbsp;
									</td>
									<td className="teks-kanan">
										{item.opsen_pkb.toLocaleString('id')}<br />&nbsp;<br />&nbsp;
									</td>
									<td className="teks-kanan">
										{(item.jumlah_pokok + item.opsen_pkb + item.opsen_bbnkb).toLocaleString('id')}<br />
										{item.jumlah_denda.toLocaleString('id')}<br />
										{(item.jumlah_semua + item.opsen_pkb + item.opsen_bbnkb).toLocaleString('id')}
									</td>
								</tr>
							);
						})}
						{/* Total row in tbody — muncul hanya sekali di halaman terakhir */}
						<tr><td colSpan={15} style={{ padding: 4 }}></td></tr>
						<tr>
							<td colSpan={8} className="teks-kanan" style={{ fontWeight: 'bold' }}>
								JUMLAH TANGGAL {data.summary.jum_tgl_sd}
							</td>
							<td className="teks-kanan">
								{data.summary.pkb_pokok.toLocaleString('id')}<br />
								{data.summary.pkb_denda.toLocaleString('id')}<br />
								{(data.summary.pkb_pokok + data.summary.pkb_denda).toLocaleString('id')}
							</td>
							<td className="teks-kanan">
								{data.summary.pokok_bbn_i.toLocaleString('id')}<br />
								{data.summary.denda_bbn_i.toLocaleString('id')}<br />
								{(data.summary.pokok_bbn_i + data.summary.denda_bbn_i).toLocaleString('id')}
							</td>
							<td className="teks-kanan">
								{data.summary.pokok_bbn_ii.toLocaleString('id')}<br />
								{data.summary.denda_bbn_ii.toLocaleString('id')}<br />
								{(data.summary.pokok_bbn_ii + data.summary.denda_bbn_ii).toLocaleString('id')}
							</td>
							<td className="teks-kanan">
								{data.summary.swdkllj_pokok.toLocaleString('id')}<br />
								{data.summary.swdkllj_denda.toLocaleString('id')}<br />
								{(data.summary.swdkllj_pokok + data.summary.swdkllj_denda).toLocaleString('id')}
							</td>
							<td className="teks-kanan">
								{data.summary.opsen_bbnkb.toLocaleString('id')}<br />0<br />0
							</td>
							<td className="teks-kanan">
								{data.summary.opsen_pkb.toLocaleString('id')}<br />0<br />0
							</td>
							<td className="teks-kanan">
								{(
									data.summary.pkb_pokok + data.summary.pokok_bbn_i +
									data.summary.pokok_bbn_ii + data.summary.swdkllj_pokok +
									data.summary.opsen_bbnkb + data.summary.opsen_pkb
								).toLocaleString('id')}<br />
								{(
									data.summary.pkb_denda + data.summary.denda_bbn_i +
									data.summary.denda_bbn_ii + data.summary.swdkllj_denda
								).toLocaleString('id')}<br />
								{(
									(data.summary.pkb_pokok + data.summary.pokok_bbn_i + data.summary.pokok_bbn_ii + data.summary.swdkllj_pokok) +
									(data.summary.pkb_denda + data.summary.denda_bbn_i + data.summary.denda_bbn_ii + data.summary.swdkllj_denda) +
									(data.summary.opsen_bbnkb + data.summary.opsen_pkb)
								).toLocaleString('id')}
							</td>
						</tr>
					</tbody>
				</table>

				<br /><br />
				<table border="0" cellPadding="5">
					<tbody>
						<tr>
							<td colSpan={7}>REKAPITULASI JUMLAH KENDARAAN</td>
						</tr>
						<tr>
							<td style={{ width: 250 }}>
								{data.data.rekap.map((item, id) => (
									<React.Fragment key={id}>{item.rek_jenis}<br /></React.Fragment>
								))}
							</td>
							<td style={{ width: 10 }}>
								{data.data.rekap.map((item, id) => (
									<React.Fragment key={id}>{item.rek_batas}<br /></React.Fragment>
								))}
							</td>
							<td style={{ width: 200 }}>
								{data.data.rekap.map((item, id) => (
									<React.Fragment key={id}>{item.rek_jum}<br /></React.Fragment>
								))}
							</td>
							<td style={{ width: 400 }}></td>
							<td style={{ width: 150 }}>
								{data.summary.jum_kend1}<br />
								{data.summary.jum_pkb1}<br />
								{data.summary.jum_swd1}
							</td>
							<td style={{ width: 10 }}>
								{data.summary.jum_kend2}<br />
								{data.summary.jum_pkb2}<br />
								{data.summary.jum_swd2}
							</td>
							<td style={{ width: 200 }}>
								{data.summary.jum_kend3}<br />
								{data.summary.jum_pkb3}<br />
								{data.summary.jum_swd3}
							</td>
						</tr>
					</tbody>
				</table>

				<br /><br />
				<table>
					<tbody>
						<tr className="teks-tengah">
							<td style={{ padding: '0 40px' }}>
								Mengetahui,<br />
								{data.ttd.kiri.jabatan}
							</td>
							<td style={{ padding: '0 40px' }}>
								<br />{data.ttd.tengah.jabatan}
							</td>
							<td style={{ padding: '0 40px' }}>
								{data.ttd.tgl_tempat}<br />
								{data.ttd.kanan.jabatan}
							</td>
						</tr>
						<tr><td colSpan={3} style={{ height: 60 }}></td></tr>
						<tr className="teks-tengah">
							<td style={{ padding: '0 40px' }}><b>{data.ttd.kiri.nama}</b></td>
							<td style={{ padding: '0 40px' }}><b>{data.ttd.tengah.nama}</b></td>
							<td style={{ padding: '0 40px' }}><b>{data.ttd.kanan.nama}</b></td>
						</tr>
						<tr className="teks-tengah">
							<td style={{ padding: '0 40px' }}>{data.ttd.kiri.nip}</td>
							<td style={{ padding: '0 40px' }}>{data.ttd.tengah.nip}</td>
							<td style={{ padding: '0 40px' }}>{data.ttd.kanan.nip}</td>
						</tr>
					</tbody>
				</table>
			</div>
		);
	}

	render() {
		const { loading, data } = this.state;

		const NAVY     = '#0f2847';
		const NAVY_MID = '#1a3a6b';

		const labelFilter = (txt) => (
			<span style={{ fontSize: 11, fontWeight: 600, color: '#475569', textTransform: 'uppercase', letterSpacing: .5 }}>{txt}</span>
		);

		return (
			<div>
				<Helmet>
					<title>{configClass.title + " | " + config.get_site_info().name}</title>
				</Helmet>

				{/* ── Konten layar: disembunyikan saat print ── */}
				<div className="lap-sum32-screen">

					<div className="card">
						<Row className="isi" gutter={[0, 14]}>

							{/* ══════════════════ FILTER PANEL ══════════════════ */}
							<Col span={24}>
								<div style={{ background: '#fff', borderRadius: 14, overflow: 'hidden', border: '1px solid #e2e8f0', boxShadow: '0 2px 12px rgba(15,40,71,0.07)' }}>

									{/* Header dark navy */}
									<div style={{ background: `linear-gradient(135deg, ${NAVY} 0%, ${NAVY_MID} 100%)`, padding: '16px 20px' }}>
										<div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
											<div style={{ width: 36, height: 36, background: 'rgba(251,191,36,0.15)', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>📊</div>
											<div>
												<div style={{ fontSize: 14, fontWeight: 700, color: '#fff', letterSpacing: .3 }}>Laporan SUM32</div>
												<div style={{ fontSize: 11, color: '#64748b' }}>Buku penerimaan harian PKB, BBNKB, dan SWDKLLJ</div>
											</div>
										</div>
									</div>

									{/* Filter form */}
									<Form
										layout="vertical"
										name="fdata"
										onFinish={this.handleSubmit}
										size="small"
										ref={this.formRef}
										disabled={loading}
										style={{ padding: '18px 20px 14px' }}
									>
										<div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '0 16px' }}>

											<Form.Item name="kabupaten" label={labelFilter('Kabupaten')} style={{ marginBottom: 10 }}>
												{this.generateSelect("Kabupaten", configClass.apiUrl.kabupaten, "id", "name")}
											</Form.Item>

											<Form.Item name="upt" label={labelFilter('UPT')} style={{ marginBottom: 10 }}>
												{this.generateSelect("Upt", configClass.apiUrl.upt, "id", "nama", "id")}
											</Form.Item>

											<Form.Item name="jenis_kendaraan" label={labelFilter('Jenis Kendaraan')} style={{ marginBottom: 10 }}>
												{this.generateSelect("JenisKendaraan", configClass.apiUrl.jenis_kendaraan, "id", "nama", "kode")}
											</Form.Item>

											<Form.Item name="warna_plat" label={labelFilter('Warna Plat')} style={{ marginBottom: 10 }}>
												{this.generateSelect("WarnaPlat", configClass.apiUrl.warna_plat, "id", "nama", "kode")}
											</Form.Item>

											<Form.Item name="roda" label={labelFilter('Jumlah Roda')} style={{ marginBottom: 10 }}>
												<Input placeholder="cth: 2" size="small" style={{ borderRadius: 8 }} />
											</Form.Item>

											<Form.Item name="payment_type" label={labelFilter('Jenis Pembayaran')} style={{ marginBottom: 10 }}>
												{this.generateSelect("Payment", configClass.apiUrl.payment, "id", "nama", "kode")}
											</Form.Item>

											<Form.Item name="mulai_dari_picker" label={labelFilter('Periode Mulai')} style={{ marginBottom: 10 }}>
												<DatePicker
													placeholder="dd-mm-yyyy"
													format="DD-MM-YYYY"
													style={{ width: '100%', borderRadius: 8 }}
													onChange={(date, dateString) => {
														this.formRef.current.setFieldsValue({ mulai_dari: dateString });
													}}
												/>
											</Form.Item>

											<Form.Item name="sampai_dengan_picker" label={labelFilter('Sampai Dengan')} style={{ marginBottom: 10 }}>
												<DatePicker
													placeholder="dd-mm-yyyy"
													format="DD-MM-YYYY"
													style={{ width: '100%', borderRadius: 8 }}
													onChange={(date, dateString) => {
														this.formRef.current.setFieldsValue({ sampai_dengan: dateString });
													}}
												/>
											</Form.Item>

										</div>

										{/* Hidden fields */}
										<Form.Item name="mulai_dari" style={{ display: 'none' }}><Input type="hidden" /></Form.Item>
										<Form.Item name="sampai_dengan" style={{ display: 'none' }}><Input type="hidden" /></Form.Item>

										{/* Action buttons */}
										<div style={{ display: 'flex', gap: 10, paddingTop: 4 }}>
											<Button
												loading={loading}
												type="primary"
												htmlType="submit"
												disabled={loading}
												icon={!loading && <SearchOutlined />}
												style={{
													borderRadius: 9, height: 36, paddingInline: 20, fontWeight: 700,
													background: NAVY, borderColor: NAVY,
												}}
											>
												Proses Laporan
											</Button>
											{data != null && (
												<Button
													htmlType="button"
													disabled={loading}
													icon={!loading && <PrinterOutlined />}
													style={{ borderRadius: 9, height: 36, paddingInline: 20, fontWeight: 600 }}
													onClick={this.handlePrint}
												>
													Cetak
												</Button>
											)}
										</div>
									</Form>
								</div>
							</Col>

							{/* ══════════════════ LOADING STATE ══════════════════ */}
							{loading && (
								<Col span={24}>
									<div style={{ background: '#fff', borderRadius: 14, padding: '28px', textAlign: 'center', border: '1px solid #e2e8f0' }}>
										<Spin size="large" />
										<div style={{ marginTop: 12, color: '#64748b', fontSize: 13 }}>Memproses laporan, mohon tunggu...</div>
									</div>
								</Col>
							)}

							{/* ══════════════════ HASIL LAPORAN ══════════════════ */}
							{data != null && !loading && (
								<Col span={24}>
									<div style={{ background: '#fff', borderRadius: 14, border: '1px solid #e2e8f0', overflow: 'auto', padding: '16px 20px' }}>
										{this.renderLaporanContent()}
									</div>
								</Col>
							)}

						</Row>
					</div>
				</div>{/* end lap-sum32-screen */}

				{/* ── Print-only section (tersembunyi di layar, dipindah ke body oleh JS saat cetak) ── */}
				<div className="lap-sum32-print-only" style={{ padding: 20 }}>
					{data != null && this.renderLaporanContent()}
				</div>
			</div>
		);
	}
}

const mapStateToProps = function (state) {
	return state.configReducers
}

export default connect(
	mapStateToProps,
	{
		initHandler,
		setConfig,
		ajaxViewHandler,
		ajaxHandler
	}
)(LapSUM32);
